module.exports = JSON.parse('{"Clear dates":"Borrar fechas","End Date":"Fecha fin","Start Date":"Fecha inicio"}')